import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select2 = _resolveComponent("Select2")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group form-group-block form-group-select", [ _ctx.disabled ? 'disabled' : '' , _ctx.borderClass ]])
  }, [
    _createVNode(_component_Select2, {
      modelValue: _ctx.itemSelected,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSelected) = $event)),
      options: _ctx.options,
      settings: {
        placeholder: _ctx.placeholder,
        minimumResultsForSearch: Infinity,
      },
      onSelect: _ctx.selectEvent,
      disabled: _ctx.disabled
    }, null, 8, ["modelValue", "options", "settings", "onSelect", "disabled"])
  ], 2))
}